import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/user-role.types';

@Injectable({ providedIn: 'root' })
export class ViewerGuardService implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);
  private readonly user = this.authService.currentUser;

  canActivate(): boolean {
    const user = this.user();
    if (user && user.role !== UserRole.VIEWER) {
      return true;
    } else {
      this.router.navigate(['/main/knowledge-base']);
      return false;
    }
  }
}
